import { memo, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Skeleton, Typography, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _map from 'lodash/map';
// Local files
import { StyledList, StyledListItem } from './BaseEventsList.styled';
import LogsHistoryDialog from 'components/Dialogs/LogsHistory/LogsHistory';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const EventList = ({ data, pagination, analysisId, eventsFetching, fetchEvents, expanded, handleChangeExpand, expandButton = true }) => {
  const [logsHisoryDialog, setLogsHisoryDialog] = useState({ open: false, analysisId: '', fetchEvents: null });

  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) =>
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !eventsFetching && fetchEvents(pagination.limit + pagination.offset, analysisId);
  const handleCreate = () => setLogsHisoryDialog({ open: true, analysisId, fetchEvents });
  const handleClose = () => setLogsHisoryDialog({ open: false, analysisId: '', fetchEvents: null });

  return (
    <>
      <LogsHistoryDialog {...logsHisoryDialog} onClose={handleClose} />
      <Accordion
        expanded={expanded}
        onChange={handleChangeExpand}
        sx={{ mt: 3, backgroundColor: 'background.default' }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Logs History</AccordionSummary>
        <AccordionDetails>
          { !eventsFetching && expandButton && <Button variant='outlined' onClick={handleCreate} sx={{ mb: 2, width: '100%' }}>Expand history log</Button>}
          <StyledList onScroll={handleScroll}>
            {_map(data, (e) => (
              <StyledListItem key={e.id}>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                  <Typography variant='body2' color='textSecondary' sx={{ fontWeight: 800 }}>
                    {!!e?.created_at ?
                      `${new Date(e.created_at).toLocaleString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })}`
                      : '-'
                    }
                  </Typography>
                  <Typography variant='body2' color='textSecondary' sx={{ wordBreak: 'break-word', fontWeight: 400 }}>
                    {e?.text ?? '-'}
                  </Typography>
                </Box>
              </StyledListItem>
            ))}
            {eventsFetching && <Skeleton variant="rectangular" width='95%' height={30} />}
            {data.length === 0 && !eventsFetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No Logs</Typography>}
          </StyledList>
        </AccordionDetails>
      </Accordion>
    </>
    
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <EventList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);